import React from 'react';
import LineIcon from "react-lineicons";

function TechStackItem(props){
  return (
    <div className="mi-service">
      <span className="mi-service-icon">
        <LineIcon name={props.content.icon} />
      </span>
      <p>{props.content.name}</p>
    </div>
  )
}

export default TechStackItem;
